import React, { ChangeEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  CardMedia,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import "react-phone-input-2/lib/bootstrap.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PhoneInput from "react-phone-input-2";

const EditUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [Status, setStatus] = React.useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const isAddUser = location.pathname === "/manage-users/add";

  const [fileName, setFileName] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>{isAddUser ? "Add " : "Edit "} User</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>
            Manage Users
          </button>{" "}
          - {isAddUser ? "Add " : "Edit "} User
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label htmlFor="icon-button-file">Profile Picture</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage("This field only accepts images.");
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_33">
              <label htmlFor="full-name">First Name</label>
              <TextField
                id="full-name"
                placeholder="First Name"
                hiddenLabel
                fullWidth
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="full-name">Last Name</label>
              <TextField
                id="full-name"
                placeholder="Last Name"
                hiddenLabel
                fullWidth
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="email">Email Address</label>
              <TextField
                id="email"
                type="email"
                placeholder="Email Address"
                hiddenLabel
                fullWidth
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="phone">Phone Number</label>
              <PhoneInput
                country={"in"}
                placeholder="Enter Phone Number"
                enableSearch={false}
                autoFormat={false}
                inputStyle={{ width: "100%" }}
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="address">Address</label>
              <TextField
                id="address"
                placeholder="Address"
                hiddenLabel
                fullWidth
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="city">City</label>
              <TextField id="city" placeholder="City" hiddenLabel fullWidth />
            </div>
            <div className="control_group w_33">
              <label htmlFor="country">Country</label>
              <TextField
                id="country"
                placeholder="Country"
                hiddenLabel
                fullWidth
              />
            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
